import React, { useState, useEffect } from 'react';
import { Button, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useSelector, useDispatch } from 'react-redux';
import * as ActionsDialog from 'app/store/actions';

const useStyles = makeStyles(theme => ({
	paper: {
		maxWidth: '100%'
	},
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		maxWidth: '100%',
		height: '49px',
		color: 'white',
		padding: '20px',
		backgroundColor: theme.palette.secondary.main
	},
	body: {
		display: 'flex',
		flexFlow: 'row',
		alignItems: 'top',
		justifyContent: 'space-around',
		width: '100%',
		padding: '16px 0'
	},
	table: {
		'& th': {
			padding: '8px',
			paddingRight: '32px',
			textAlign: 'left',
			minWidth: '88px'
		},
		'& td': {
			textAlign: 'left'
		}
	},
	red: {
		color: '#b83b47'
	}
}));

const NodeDisplay = props => {
	const dispatch = useDispatch();
	const classes = useStyles(props);

	const [status, setStatus] = useState({});

	const node = useSelector(({ clusters }) => clusters.cluster.node);

	useEffect(() => {
		if (node && props.mgr === 'torque') {
			if (!node.status) {
				node.status =
					'opsys=unknown,uname=unknown, sessions=unknown,nsessions=unknown,nusers=unknown,idletime=unknown,totmem=unknown, availmem=unknown,physmem=unknown,ncpus=unknown,loadave=unknown,gres=,netload=unknown,state=unknown,varattr= ,cpuclock=unknown,macaddr=unknown,version=unknown,rectime=unknown,jobs=';
			}
			const obj = {};
			const arr = node.status.split(',');
			arr.forEach(n => {
				const subArr = n.split('=');
				obj[subArr[0]] = subArr[1];
			});
			setStatus(obj);
		}
	}, [node, props.mgr]);

	const parseJobs = () => {
		let jobs = [];
		if (node.jobs) {
			jobs = node.jobs.split(',');
		}
		return jobs.length;
	};

	const back = () => {
		dispatch(ActionsDialog.closeDialog());
	};

	return (
		<React.Fragment>
			{node && (
				<Paper className={classes.paper}>
					<header className={classes.header}>
						<Typography variant="h4">{node.name}</Typography>
						<Button onClick={back} variant="contained">
							X
						</Button>
					</header>
					{props.mgr === 'slurm' ? (
						<div className={classes.body}>
							<table className={classes.table}>
								<tbody>
									<tr>
										<th>State:</th>
										<td>{node.state || 'N/A'}</td>
									</tr>
									<tr>
										<th>Addres:</th>
										<td>{node.address || 'N/A'}</td>
									</tr>
									<tr>
										<th>Architecture:</th>
										<td>{node.architecture || 'N/A'}</td>
									</tr>
									<tr>
										<th>Boards:</th>
										<td>{node.boards || 'N/A'}</td>
									</tr>
									<tr>
										<th>Boot Time:</th>
										<td>{node.boot_time || 'N/A'}</td>
									</tr>
									<tr>
										<th>Burst Buffer Net Address:</th>
										<td>{node.burstbuffer_network_address || 'N/A'}</td>
									</tr>
									<tr>
										<th>Cores:</th>
										<td>{node.cores || 'N/A'}</td>
									</tr>
									<tr>
										<th>CPU Binding:</th>
										<td>{node.cpu_binding || 'N/A'}</td>
									</tr>
									<tr>
										<th>CPU Load:</th>
										<td>{node.cpu_load || 'N/A'}</td>
									</tr>
									<tr>
										<th>CPUs:</th>
										<td>{node.cpus || 'N/A'}</td>
									</tr>
									<tr>
										<th>Features:</th>
										<td>{node.features || 'N/A'}</td>
									</tr>
									<tr>
										<th>Free Memory:</th>
										<td>{node.free_memory || 'N/A'}</td>
									</tr>
									<tr>
										<th>Generic Resources:</th>
										<td>{node.gres || 'N/A'}</td>
									</tr>
									<tr>
										<th>Generic Resources Drained:</th>
										<td>{node.gres_drained || 'N/A'}</td>
									</tr>
									<tr>
										<th>Generic Resources Used:</th>
										<td>{node.gres_used || 'N/A'}</td>
									</tr>
									<tr>
										<th>Hostname:</th>
										<td>{node.hostname || 'N/A'}</td>
									</tr>
								</tbody>
							</table>
							<table className={classes.table}>
								<tbody>
									<tr>
										<th>Multi-Category Security (MCS):</th>
										<td>{node.mcs_label || 'N/A'}</td>
									</tr>
									{/* <tr>
										<th>State After Reboot:</th>
										<td>{node.next_state_after_reboot || 'N/A'}</td>
									</tr> */}
									<tr>
										<th>Active Features:</th>
										<td>{node.active_features || 'N/A'}</td>
									</tr>
									<tr>
										<th>Owner:</th>
										<td>{node.owner || 'N/A'}</td>
									</tr>
									<tr>
										<th>Port:</th>
										<td>{node.port || 'N/A'}</td>
									</tr>
									<tr>
										<th>Real Memory:</th>
										<td>{node.real_memory || 'N/A'}</td>
									</tr>
									<tr>
										<th>Reason:</th>
										<td>{node.reason || 'N/A'}</td>
									</tr>
									<tr>
										<th>Reason Changed:</th>
										<td>{node.reason_changed_at || 'N/A'}</td>
									</tr>
									<tr>
										<th>Reason Set by User:</th>
										<td>{node.reason_set_by_user || 'N/A'}</td>
									</tr>
									<tr>
										<th>Slurmd Start Time:</th>
										<td>{node.slurmd_start_time || 'N/A'}</td>
									</tr>
									<tr>
										<th>Slurmd Version:</th>
										<td>{node.slurmd_version || 'N/A'}</td>
									</tr>
									<tr>
										<th>Sockets:</th>
										<td>{node.sockets || 'N/A'}</td>
									</tr>
									<tr>
										<th>Temp Disk:</th>
										<td>{node.temporary_disk || 'N/A'}</td>
									</tr>
									<tr>
										<th>Threads:</th>
										<td>{node.threads || 'N/A'}</td>
									</tr>
									<tr>
										<th>Trackable Resources:</th>
										<td>{node.tres || 'N/A'}</td>
									</tr>
									<tr>
										<th>Weight:</th>
										<td>{node.weight || 'N/A'}</td>
									</tr>
								</tbody>
							</table>
						</div>
					) : (
						<div className={classes.body}>
							<table className={classes.table}>
								<tbody>
									<tr>
										<th>State:</th>
										<td>{node.state || 'N/A'}</td>
									</tr>
									<tr>
										<th>Power State:</th>
										<td>{node.power_state || 'N/A'}</td>
									</tr>
									<tr>
										<th>Processors:</th>
										<td>{node.np || 'N/A'}</td>
									</tr>
									<tr>
										<th>Type:</th>
										<td>{node.ntype || 'N/A'}</td>
									</tr>
									<tr>
										<th>Service Port:</th>
										<td>{node.mom_service_port || 'N/A'}</td>
									</tr>
									<tr>
										<th>Manager Port:</th>
										<td>{node.mom_manager_port || 'N/A'}</td>
									</tr>
									<tr>
										<th>Total Sockets:</th>
										<td>{node.total_sockets || 'N/A'}</td>
									</tr>
									<tr>
										<th>Total Nodes:</th>
										<td>{node.total_numa_nodes || 'N/A'}</td>
									</tr>
									<tr>
										<th>Total Cores:</th>
										<td>{node.total_cores || 'N/A'}</td>
									</tr>
									<tr>
										<th>Total Threads:</th>
										<td>{node.total_threads || 'N/A'}</td>
									</tr>
									<tr>
										<th>Dedicated Sockets:</th>
										<td>{node.dedicated_sockets || 'N/A'}</td>
									</tr>
									<tr>
										<th>Dedicated Nodes:</th>
										<td>{node.dedicated_numa_nodes || 'N/A'}</td>
									</tr>
									<tr>
										<th>Dedicated Cores:</th>
										<td>{node.dedicated_cores || 'N/A'}</td>
									</tr>
									<tr>
										<th>Dedicated Threads:</th>
										<td>{node.dedicated_threads || 'N/A'}</td>
									</tr>
									<tr>
										<th>Operating System:</th>
										<td>{status.opsys || 'N/A'}</td>
									</tr>
									<tr>
										<th>User:</th>
										<td>{status.nusers || 'N/A'}</td>
									</tr>
								</tbody>
							</table>
							<table className={classes.table}>
								<tbody>
									<tr>
										<th>Sessions:</th>
										<td>{status.sessions || 'N/A'}</td>
									</tr>
									<tr>
										<th>N Sessions:</th>
										<td>{status.nsessions || 'N/A'}</td>
									</tr>
									<tr>
										<th>Idle Time:</th>
										<td>{status.idletime || 'N/A'}</td>
									</tr>
									<tr>
										<th>Total Memory:</th>
										<td>{status.totmem || 'N/A'}</td>
									</tr>
									<tr>
										<th>Available Memory:</th>
										<td>{status.availmem || 'N/A'}</td>
									</tr>
									<tr>
										<th>Physical Memory:</th>
										<td>{status.physmem || 'N/A'}</td>
									</tr>
									<tr>
										<th>CPUs:</th>
										<td>{status.ncpus || 'N/A'}</td>
									</tr>
									<tr>
										<th>Load Average:</th>
										<td>{status.loadave}%</td>
									</tr>
									<tr>
										<th>Net Load:</th>
										<td>{status.netload || 'N/A'}</td>
									</tr>
									<tr>
										<th>State:</th>
										<td>{status.state || 'N/A'}</td>
									</tr>
									<tr>
										<th>CPU Clock:</th>
										<td>{status.cpuclock || 'N/A'}</td>
									</tr>
									<tr>
										<th>MAC Address:</th>
										<td>{status.macaddr || 'N/A'}</td>
									</tr>
									<tr>
										<th>Torque Version:</th>
										<td>{status.version || 'N/A'}</td>
									</tr>
									<tr>
										<th>REC Time:</th>
										<td>{status.rectime || 'N/A'}</td>
									</tr>
									<tr>
										<th>Jobs:</th>
										<td>{parseJobs()}</td>
									</tr>
									<tr>
										<th>Note:</th>
										<td className={classes.red}>{node.note || ''}</td>
									</tr>
								</tbody>
							</table>
						</div>
					)}
				</Paper>
			)}
		</React.Fragment>
	);
};

export default NodeDisplay;
